import { useEffect, useState } from 'react';
import { onlineStatusService } from '../services/online-status.service';

/**
 * A hook that returns the current online/offline connectivity state.
 *
 * Subscribes to an internal onlineStatusService and updates on connectivity changes;
 *
 * Cleans up the subscription automatically on unmount.
 *
 * @remark If offline mode is disabled, this hook will always return true.
 *
 * @returns {boolean} true if the application is online; otherwise false.
 */
export const useOnlineStatus = (): boolean => {
  const [isOnline, setIsOnline] = useState(() => onlineStatusService.getStatus());

  useEffect(() => {
    const unsubscribe = onlineStatusService.subscribe(setIsOnline);

    // Cleanup on unmount
    return () => unsubscribe();
  }, []);

  return isOnline;
};
